export const Colors = {
    RED:"#CC1111",
    YELLOW:"#F3EED8",
    FAINT_RED:"#CC111126",
    GREEN:"#05A580",
    FAINT_GREEN:"#05A5801A"
}